import { Layers, Gauge, Lock, Maximize2, LifeBuoy } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { SectionTag } from "./About";

const ICONS = [Layers, Gauge, Lock, Maximize2, LifeBuoy];

export default function WhyUs() {
  const { t } = useLang();
  return (
    <section
      id="why"
      className="relative py-24 sm:py-32 border-t border-white/5 bg-[#050B14]"
      data-testid="why-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="max-w-3xl">
          <SectionTag>{t.why.tag}</SectionTag>
          <h2
            className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl text-white font-bold leading-[1.1]"
            data-testid="why-title"
          >
            {t.why.title}
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[rgba(0,240,255,0.12)] border border-[rgba(0,240,255,0.12)]">
          {t.why.items.map((it, i) => {
            const Icon = ICONS[i] || Layers;
            return (
              <div
                key={i}
                className="group relative bg-[#050B14] hover:bg-[#08152a] p-7 transition-colors"
                data-testid={`why-item-${i}`}
              >
                <div className="w-11 h-11 inline-flex items-center justify-center border border-[rgba(0,240,255,0.25)] text-[#00F0FF] group-hover:border-[#00F0FF] group-hover:shadow-[0_0_20px_rgba(0,240,255,0.35)] transition-all">
                  <Icon size={20} />
                </div>
                <h3 className="font-display mt-5 text-lg text-white font-semibold">
                  {it.title}
                </h3>
                <p className="mt-2 text-sm sm:text-[15px] text-slate-300 leading-[1.75]">
                  {it.desc}
                </p>
                <span className="absolute top-0 start-0 w-2 h-2 bg-[#00F0FF] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
